export const ENV = {
  API_BASE_URL: (import.meta.env['VITE_API_BASE_URL'] as string | undefined) ?? 'http://localhost:8787',
  SHOP_DOMAIN:  (import.meta.env['VITE_SHOP_DOMAIN']  as string | undefined) ?? '',
  APP_ENV:      (import.meta.env['VITE_APP_ENV']       as string | undefined) ?? 'development',
  APP_HANDLE:   (import.meta.env['VITE_APP_HANDLE']    as string | undefined) ?? 'dtlab',
} as const

export const IS_DEV  = ENV.APP_ENV === 'development'
export const IS_PROD = ENV.APP_ENV === 'production'
